import { factory, am } from './utils';

import httpClient from '@/utils/httpClient';
import { lw } from '@/utils/lw';

const GENERATE = am(`GENERATE`);
const INITIALIZE = 'INITIALIZE';

const LOCAL_STORAGE_USAGE_KEY = 'OUTLOOK_COMPOSE_USAGE';

export default {
  namespaced: true,
  ...factory({
    state: {
      message: null,
      warnings: [],
      isGenerateRequestPending: false,
      isGenerateRequestFailed: false,
      isGenerateRequestCompleted: false
    },
    getters: {
      sorted: state => {
        if (!state.collection || !state.collection.length) {
          return [];
        }

        const usage = lw.get(LOCAL_STORAGE_USAGE_KEY) || {};

        return Array.from(state.collection)
          .map(item => {
            return {
              ...item,
              usage: usage[item.id] || 0
            };
          })
          .sort((a, b) => {
            return b.usage - a.usage || a.name.localeCompare(b.name);
          });
      }
    },
    mutations: {
      [GENERATE.STARTED](state) {
        state.isGenerateRequestPending = true;
        state.isGenerateRequestFailed = false;
        state.isGenerateRequestCompleted = false;

        state.message = null;
        state.warnings = [];
      },
      [GENERATE.FAILED](state) {
        state.isGenerateRequestPending = false;
        state.isGenerateRequestFailed = true;
      },
      [GENERATE.COMPLETED](state, { templateId, message, warnings }) {
        state.isGenerateRequestPending = false;
        state.isGenerateRequestCompleted = true;

        state.warnings = warnings;
        state.message = message;

        const usage = lw.get(LOCAL_STORAGE_USAGE_KEY) || {};
        usage[templateId] = !!usage[templateId] ? usage[templateId] + 1 : 1;

        lw.set(LOCAL_STORAGE_USAGE_KEY, usage);
      },
      [INITIALIZE](state) {
        state.isGenerateRequestPending = false;
        state.isGenerateRequestFailed = false;
        state.isGenerateRequestCompleted = false;
      }
    },
    actions: {
      async generate({ commit }, { templateId, skipCache, params }) {
        commit(GENERATE.STARTED);

        try {
          const response = await httpClient.request(`/api/generate/message`, {
            method: 'POST',
            body: {
              templateId,
              params
            },
            headers: {
              'x-no-cache': skipCache
            }
          });

          const validationResult = await httpClient.request(`/api/client-guard/validate`, {
            method: 'POST',
            body: {
              subject: response.subject,
              to: response.to.map(emailAddress => ({ emailAddress })),
              cc: response.cc.map(emailAddress => ({ emailAddress })),
              bcc: response.bcc.map(emailAddress => ({ emailAddress }))
            }
          });

          const warnings = [];

          for (const key of ['to', 'cc', 'bcc']) {
            const collection = [];

            for (const item of response[key]) {
              if (validationResult[key].findIndex(vi => vi.status === 'unknown' && vi.emailAddress === item) !== -1) {
                warnings.push({
                  fieldName: key,
                  emailAddress: item
                });
              } else {
                collection.push(item);
              }
            }
            response[key] = collection;
          }

          commit(GENERATE.COMPLETED, {
            templateId,
            message: response,
            warnings
          });
          return response;
        } catch (e) {
          commit(GENERATE.FAILED);
          throw e;
        }
      },
      async initialize({ commit }) {
        commit(INITIALIZE);
      }
    }
  })('messages', {
    async getById(id) {
      return httpClient.get(`/api/messages/${id}`);
    },
    async getCollection() {
      return httpClient.get('/api/messages/');
    },
    async create(data) {
      return httpClient.post('/api/messages/', data);
    },
    async update(id, data) {
      return httpClient.patch(`/api/messages/${id}`, data);
    },
    async delete(id) {
      return httpClient.delete(`/api/messages/${id}`);
    }
  })
};
